import React, { useState } from 'react';
import objectassign from 'core-js/fn/object/assign';
import { ContextUrl } from '../../common/utils/ContextUrl';
import FormValidation from './FormValidation';
import AdaApi from '../../common/api/adaAPI';
import '../../../authortools/components/Tool/_buttons.scss';
import Preloader from '../Preloader';
import './login.scss'

const LoginForm = (props) => {
    const [formData, setFormData] = useState({});
    const [emailErrorMessage, setEmailErrorMessage] = useState(' ');
    const [confirmNoErrorMessage, setConfirmNoErrorMessage] = useState(' ');
    const [errorMessage, setErrorMessage] = useState('');
    const [formValid, setFormValid] = useState(false);
    const [emailBlurred, setEmailBlurred] = useState(false);
    const [confirmNoBlurred, setConfirmNoBlurred] = useState(false);
    const [isRegValid, setIsRegValid] = useState(true);
    const formClass = 'ada-form';

    const adaApi = new AdaApi();

    const onSubmit = (e) => {
        if (!formValid) {
            return;
        }

        const loader = new Preloader();
        loader.within(`.${formClass}`).show();

        const hideLoader = () => {
            loader.hide();
        };

        adaApi.loginUser(formData)
            .then(response => {
                setErrorMessage(null);

                if (response.data) {
                    //init the new cookie reader
                    window.hubCookie.set(response.data, { expires: window.hubConfig.loginCookieExpires });

                    const contextUrl = ContextUrl.get(window.location.search);
                    const redirectUrl = contextUrl || props.successUrl || window.hubConfig.defaultMemberUrl;
                    window.location = redirectUrl;
                } else {
                    hideLoader();
                }
            })
            .catch(error => {
                hideLoader();

                let msg = 'An error encountered on the server. Please try again.';

                if (error.response && error.response.status === 401) {
                    msg = 'Your registration cannot be verified';
                    setIsRegValid(false);
                }

                setErrorMessage(msg);
            });
    }

    const updateFormData = (update) => {
        const data = {};
        objectassign(data, formData, update);
        setFormData(data);
    };

    const setFormValidity = () => {
       const isValid = !emailErrorMessage && !confirmNoErrorMessage;
       setFormValid(isValid);
    };

    const trim = (value) => {
        value = value || '';
        return value.trim();
    };

    const validateEmail = (value) => {
        //validate confirmation number
        value = trim(value);
        let message = '';
        const result = FormValidation.validateEmail(value);

        if (result.success) {
            updateFormData({ email: value });
        } else {
            message = result.message;
        }
        setEmailErrorMessage(message);
        setFormValid(!message && !confirmNoErrorMessage);
    };

    const validateConfirmNo = (value) => {
        //validate confirmation number
        value = trim(value);
        let message = '';
        const result = FormValidation.validateConfirmNo(value);
        if (result.success) {
            updateFormData({ accessCode: value });
        } else {
            message = `${result.message}. It should start with “N” followed by ten digits`;
        }
        setConfirmNoErrorMessage(message);
        setFormValid(!emailErrorMessage && !message);
    };

    const onEmailChange = (e) => {
        //if (!emailBlurred) {
          //  return;
       // }
        validateEmail(e.currentTarget.value);
    }

    const onConfirmNoChange = (e) => {
       // if (!confirmNoBlurred) {
          //  return;
        //}
        validateConfirmNo(e.currentTarget.value);
    };

    const onBlur = (e, field) => {
        if (field === 'email') {
            setEmailBlurred(true);
            validateEmail(e.currentTarget.value);
        } else {
            setConfirmNoBlurred(true);
            validateConfirmNo(e.currentTarget.value);
        }
    };

    const errorClass = 'ada-form__control--error';
    const emailClass = `ada-form__row-item ada-form__control ${trim(emailErrorMessage) ? errorClass : ''}`;
    const confirmNoClass = `ada-form__row-item ada-form__control ${trim(confirmNoErrorMessage) ? errorClass : ''}`;
    const btnClass = `ada-form__row-item ada-btn ${formValid ? '' : 'ada-btn--disabled'}`;

    const regVerificationFailedMsg = (!isRegValid ?
        <div className="ada-form__row-item d-none">
            <p className="ada-form__message">You may be receiving this message for one of the below reasons.</p>
            <ul className="ada-form__message ada-content__list">
                <li>The email address and confirmation number don’t match exactly to your registration.</li>
                <li>You started the registration process but never fully paid or completed.</li>
                <li>You originally registered for the in-person meeting in Chicago but never transferred your registration.</li>
            </ul>
            <p className="ada-form__message">Please confirm the email address and confirmation number are correct, which can be found in your registration confirmation email.</p>
            <p className="ada-form__message">
                If correct and you are still receiving this error message, go to the
                <a href={window.hubConfig.registerUrl} className="ada-link js-register-track"
                    data-track-category="Link Clicked" data-track-category="Clicked Login-Verification-Failed-Register Now"
                    onClick={() => window.ga('send', 'event', 'Link Clicked', 'Clicked Login-Verification-Failed-Register Now')}
                    target="_blank" rel="noopener"> ADA Virtual Scientific Sessions registration website</a>
                , log in, and either register new, or finish the registration process if incomplete. You will then be able to properly log in upon return.
            </p>
            <p className="ada-form__message">
                If you are still unable to login, please email ADA Registration through the 
                <a href="https://ada.cmrushelp.com/s/contactsupport" className="ada-link" target="_blank" rel="noopener"> ADA Registration Support Center </a>
                or call (866) 290-9910 (U.S.and Canada) or (415) 268-2086 (International), 9:00 a.m. - 9:00 p.m. ET, Monday to Friday.
            </p>
            <p className="ada-form__message">&nbsp;</p>
        </div>
        : ''
    );

    return (
        <div className="namsform">
            <div className="form-group text-center mt-5">
                        <label className="loginlabel">Email address*</label>
                        <input type="text" id="email" name="email" className="form-control w-300 mx-auto rounded-0 min-height-40" onChange={onEmailChange}
                    onBlur={(e) => onBlur(e, 'email')} placeholder="Email Address" />
                <span className="ada-form__row-item ada-form__row-item ada-form__error-msg js-email-error">{emailErrorMessage}</span>
                        </div>
                     
                        <div className="form-group text-center">
                        <label className="loginlabel">Access code*</label>
                        <input type="text" className="form-control w-300 mx-auto rounded-0 min-height-40" id="accessCode" name="accessCode"
                    onChange={onConfirmNoChange} onBlur={(e) => onBlur(e, 'accessCode')} placeholder="NXXXXXXXXXX"/> 
					<span className="ada-form__row-item ada-form__row-item ada-form__error-msg js-confirmno-error">{confirmNoErrorMessage}</span>
                        </div>

            {errorMessage ?
            <div className="ada-form__row">
                <div className="ada-form__row-item ada-form__error-msg ada-form__msg-container ada-message--semi-bold js-message">
                    <img src="/ada2020sessions/publishingimages/info.svg" className="ada-form__error-info" alt="Error" />{errorMessage}
                </div>
                {regVerificationFailedMsg}
            </div> :
            ''
            }
           
           <div className="form-group text-center pt-4">
                        <button type="button" className="btn login-btn rounded-0 loginbtntext" title="Log in" onClick={onSubmit} disabled={!formValid} >Log in</button> </div>

        </div>
    );
};

export default LoginForm;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Login/Form.js